export type EnumEndpointState = 'IDLE' | 'LOADING' | 'SUCCESS' | 'ERROR'

export const MY_ENDPOINT_CACHE_DURATION_MS = 5 * 60 * 1000 // 5 minutes
export const MY_ENDPOINT_TIMEOUT_MS = 30 * 1000 // 30 seconds
